import { Pipe, PipeTransform } from '@angular/core';
import { IBreadcrumbItem } from '../../shared/breadcrumb/breadcrumb.component';
import { WHITE_LABEL_BLOCKED_URLS } from '../white-label.consts';

@Pipe({
  name: 'appFilterBreadcrumbItems',
  standalone: true,
})
export class FilterBreadcrumbItemsPipe implements PipeTransform {
  private readonly blockedUrlsMap: Record<string, boolean> = WHITE_LABEL_BLOCKED_URLS
    .reduce((acc, url) => ({ ...acc, [url]: true }), {});

  public transform(breadcrumbItems: IBreadcrumbItem[] | null): IBreadcrumbItem[] {
    return (breadcrumbItems || []).filter(item => !this.blockedUrlsMap[item.link || '']);
  }
}
